import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-message-and-notifications',
    templateUrl: './message-and-notifications.component.html',
    styleUrls: ['./message-and-notifications.component.scss'],
    standalone: false
})
export class MessageAndNotificationsComponent {
  @Input() notifications;
  @Input() currentIndex;

  previousMessage() {
    this.currentIndex = this.currentIndex - 1;
    if (this.currentIndex < 0) {
      this.currentIndex = this.notifications.length - 1;
    }
    return this.currentIndex;
  }

  nextMessage() {
    this.currentIndex = this.currentIndex + 1;
    if (this.currentIndex >= this.notifications.length) {
      this.currentIndex = 0;
    }
    return this.currentIndex;
  }
  goToMessage(index) {
    this.currentIndex = index;
  }
}
